import { formatConsumerGroupForTranslations } from '@src/helpers'

import { DESCRIPTION, SIGN_UP_FALLBACK, LOG_IN_FALLBACK } from './constants'

export const getTitle = (t) => {
  if (t('d_hello_again')) return t('d_hello_again')

  return LOG_IN_FALLBACK
}

export const getDescription = (t, consumerGroup, brand) => {
  const formattedConsumerGroup =
    formatConsumerGroupForTranslations(consumerGroup)
  const translationKey = `m_log_in_description_${formattedConsumerGroup}`
  return t(translationKey) || DESCRIPTION[brand].fallback
}

export function getSignUpLabel(t) {
  if (t('d_register')) return t('d_register')

  return SIGN_UP_FALLBACK
}

export const getTabLabel = (t) => {
  return t('a_log_in') || LOG_IN_FALLBACK
}
